import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccIsin = () => {
  const response = useBondsBondFieldApi('S_ACC.ISIN');
  return response;
};
